import { useVerifyTwoFA } from "@/shared/hooks/useConfiguracion.hook";
import { yupResolver } from "@hookform/resolvers/yup";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, TextField } from "@mui/material";
import { QRCodeCanvas } from "qrcode.react";
import type { FunctionComponent } from "react";
import { Controller, useForm, type SubmitHandler } from "react-hook-form";
import * as yup from "yup";
import customAlert from "../../CustomAlert";

interface VerifyCodeForm{ 
    code: string 
}

const VerifyCodeFormSchema : yup.ObjectSchema<VerifyCodeForm> = yup.object({
    code: yup
        .string()
        .min(6, 'El token debe tener 6 dígitos')
        .required('El token es obligatorio')
})

interface QRCodeScannerProps {
    showModal: boolean
    closeModal: () => void
    QrCodeUrl: string
    BackupCodes: string[]
}

const QRCodeScanner: FunctionComponent<QRCodeScannerProps> = ({
    showModal, closeModal, QrCodeUrl, BackupCodes
}) => {

    const { control, handleSubmit, watch, reset, setValue, formState: { errors }, setError } = useForm<VerifyCodeForm>({
        defaultValues: {
            code: ''
        },
        resolver: yupResolver(VerifyCodeFormSchema)
    });

    const {
        mutate: mutateVerifyTwoFA,
        isPending: isPendingVerifyTwoFA
    } = useVerifyTwoFA();

    const handleCloseModal = () => {
        console.log('close')
        closeModal()
        reset()
    }

    const handleConfirmCode : SubmitHandler<VerifyCodeForm> = (data) => {
        console.log(data)
        mutateVerifyTwoFA(
            {
                code: data.code
            },
            {
                onSuccess: (res) => {
                    console.log(res)
                    handleCloseModal()
                    customAlert({
                        icon: 'success',
                        titulo: `Ha activado la autenticación en dos pasos (2FA) con éxito!`,
                        mensaje: 'Por su seguridad debe volver a iniciar sesión',
                        tiempo: 4,
                        toast: true,
                    });
                },
                onError: (err) => {
                    setError(
                        'code',
                        { message: err.message || 'Error inesperado. Inténtalo nuevamente.' },
                        { shouldFocus: true }
                    );
                }
            }
        )
    }

    return (
        <>
        <Dialog
            open={showModal}
            onClose={handleCloseModal}
            maxWidth="xs"
            fullWidth
            disableEscapeKeyDown
        >
            <DialogTitle className="flex justify-between items-center pb-4 pt-6 px-6 border-b border-gray-100">
                <div>
                    <h2 className="text-xl font-semibold text-gray-800">
                        Escanea el código QR
                    </h2>
                </div>
            </DialogTitle>

            <DialogContent className="">
                <p className="text-sm text-gray-600 text-center mb-2 mt-4">
                    Usa <span className="font-semibold text-[var(--color-blue-dark)]">Google Authenticator, Microsoft Authenticator</span> u otra app compatible para completar este proceso.
                </p>

                <div className="flex flex-col items-center">
                    <div className="bg-white p-4 rounded-xl mb-4">
                        <QRCodeCanvas 
                            value={QrCodeUrl} 
                            size={180} 
                            /* imageSettings={{
                                src: 'https://proud-mushroom-0841f5d10.3.azurestaticapps.net/assets/images/favicon-w0wE17zv.png',
                                x: undefined,
                                y: undefined,
                                height: 60,
                                width: 72,
                                opacity: 1,
                                excavate: true,
                            }}  */
                        />
                    </div>
                </div>

                <Divider className=""/>

                <p className="text-lg mb-2 text-center mt-4 font-medium">
                    Ingresa el token de 6 dígitos generado por tu app:
                </p>

                <div className="flex flex-col items-center">
                    <Controller
                        name="code"
                        control={control}
                        render={({ field }) => (
                            <TextField
                                {...field}
                                inputProps={{
                                    maxLength: 6,
                                    style: { textAlign: "center", letterSpacing: "8px" },
                                }}
                                placeholder="••••••"
                                variant="outlined"
                                size="small"
                                error={errors.code?.message ? true : false}
                                helperText={errors.code?.message}
                                slotProps={{formHelperText: {sx:{textAlign: 'center'}}}}
                                disabled={isPendingVerifyTwoFA}
                            />
                        )}
                    />
                </div>

                {/* {BackupCodes.length > 0 && (
                    <div className="mt-5 w-full text-center">
                    <p className="text-sm text-gray-600 font-semibold mb-2">
                        Códigos de respaldo:
                    </p>
                    <div className="grid grid-cols-2 gap-2 text-sm font-mono text-gray-700">
                        {BackupCodes.map((code, idx) => (
                        <span
                            key={idx}
                            className="bg-gray-100 px-2 py-1 rounded-md shadow-sm"
                        >
                            {code}
                        </span>
                        ))}
                    </div>
                    </div>
                )} */}

            </DialogContent>

            <DialogActions className="flex !justify-between !px-[20px] !py-[16px]">
                <Button variant="outlined" color="error" onClick={handleCloseModal} disabled={isPendingVerifyTwoFA}>
                    Cancelar
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSubmit(handleConfirmCode)}
                    className="normal-case rounded-xl px-6 shadow-md"
                    disabled={isPendingVerifyTwoFA}
                    loading={isPendingVerifyTwoFA}
                    loadingPosition="end"
                >
                    Confirmar
                </Button>
            </DialogActions>
        </Dialog>
        </>
    );
}

export default QRCodeScanner;